enum CargoOfficerAddViewMode {
  CARGO = "CARGO",
  RAILY = "RAILY",
}

export default CargoOfficerAddViewMode;
